import { render } from "./formResearch.vue?vue&type=template&id=2858fa3a&scoped=true"
import script from "./formResearch.vue?vue&type=script&lang=js"
export * from "./formResearch.vue?vue&type=script&lang=js"

import "./formResearch.vue?vue&type=style&index=0&id=2858fa3a&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2858fa3a"]])

export default __exports__